import { ObjectId } from "../../../../../shared/type-aliases/object-id";

export class CalendarClass {
  _id?: string;
  color: string;
  description: string;
  users?: string[];

  constructor(data: Partial<CalendarClass> = {}) {
    this._id = data._id;
    this.color = data.color || '';
    this.description = data.description || '';
    this.users = data.users || [];
  }
}
